import './footer.css'

const Footer = () => {
    return (
        <footer>
            <div className="footer-enlaces">
                <div>
                    <div>
                        <h2>NOSOTROS</h2>
                        <p>Productos</p>
                        <p>Servicios</p>
                    </div>
                    <div>
                        <h2>ENLACES DE INTERÉS</h2>
                        <p>FAQs</p>
                        <p>PQRS</p>
                    </div>
                </div>
                <div><img src="img/logo_blanco.png" height="80" /></div>
            </div>
            <div className="footer-contactenos">
                <div>
                    <h2>CONTÁCTANOS</h2>
                    <p>Contacto@farmedicall.com</p>
                    <p>Calle 7 # 14 - 18 Neiva, Huila</p>
                    <p>Tel. (57) 8 8711473</p>
                    <p>(57) 8 720514</p>
                    <p>Cel. (57) 317 3671647</p>
                </div>
            </div>
        </footer>
    )
}

export default Footer;